import { Children, cloneElement, isValidElement, memo, useContext } from 'react';
import type { PropsWithChildren } from 'react';

import { NodeRendererContext } from './RootNodeRenderer';

export const NodeRenderer = memo(({ children, renderIndex, ...props }: NodeRendererProps) => {
	const maxBatchRenderIndex = useContext(NodeRendererContext);
	const shouldRender = !maxBatchRenderIndex || renderIndex < maxBatchRenderIndex;

	if (!shouldRender) {
		return null;
	}

	// Some node components add props to their children, outside of `serializeFragment`. Pass such props through:
	if (Object.keys(props).length) {
		return Children.map(children, (child) =>
			isValidElement(child) ? cloneElement(child, props) : child,
		);
	}

	return children;
});

type NodeRendererProps = PropsWithChildren<{
	renderIndex: number;
}>;
